<template>
  <div id="app" v-if="$route.name">
    <transition name="slither" mode="out-in">
      <country-switcher v-if="showCountrySwitcher" />
    </transition>
    <project-list v-if="$route.name != 'OrganizationEmbed'" />
    <new-site-popup
      v-if="$route.name != 'OrganizationEmbed' && $store.state.showNewModal"
    />
    <top-nav v-if="$route.name != 'OrganizationEmbed'"></top-nav>
    <transition name="slither" mode="out-in">
      <router-view
        class="mb-10"
        :class="[
          $route.name == 'Home' ||
          $route.name == 'Organization' ||
          $route.name == 'OrganizationEmbed'
            ? ''
            : 'mt-10 container',
        ]"
      />
    </transition>
    <footer-component v-if="$route.name != 'OrganizationEmbed'" />
  </div>
</template>
<script>
import TopNav from "./components/TopNav";
import CountrySwitcher from "./components/CountrySwitcher";
import NewSitePopup from "./components/NewSitePopup";
import FooterComponent from "./components/FooterComponent";
import ProjectList from "./views/ProjectList";
import { EventBus } from "./event-bus.js";

const countryCodeExpression = /loc=([\w]{2})/;
const userIPExpression = /ip=([\w\.]+)/;
export default {
  metaInfo: {
    title: "Donate and Support Israeli Charities",
    titleTemplate: "%s | Ne'eman Foundation",
    meta: [
      {
        name: "description",
        content: "Donate and Support Israeli Charities",
      },
    ],
  },
  components: {
    NewSitePopup,
    TopNav,
    CountrySwitcher,
    FooterComponent,
    ProjectList,
  },
  data() {
    return {
      showModal: false,
      showNewModal: false,
      showCountrySwitcher: false,
    };
  },
  mounted() {
    if (!$cookies.get("NewWebSiteDismiss")) {
      $cookies.set("NewWebSiteDismiss", 1, 60 * 60 * 24 * 7);
    }
    if (this.$route.name != "OrganizationEmbed") {
      let self = this;
      // this.initCountry();
      // const urlParams = new URLSearchParams(window.location.search);
      // if (country) {
      //   self.$store.state.country = country;
      // }
      this.axios
        .get(window.API_URL + "categories")
        .then(function (response) {
          self.$store.state.categories = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  },
  methods: {
    initCountry() {
      // let self = this;
      // return new Promise((resolve, reject) => {
      //   var xhr = new XMLHttpRequest();
      //   xhr.timeout = 3000;
      //   xhr.onreadystatechange = function () {
      //     if (this.readyState == 4) {
      //       if (this.status == 200) {
      //         let countryCode = countryCodeExpression.exec(this.responseText);
      //         if (countryCode === null || countryCode[1] === "") {
      //           reject("IP/Country code detection failed");
      //         }
      //         let result = {
      //           countryCode: countryCode[1],
      //         };
      //         if (result.countryCode == "CA") {
      //           self.$store.state.country = "can";
      //         }
      //         resolve(result);
      //       } else {
      //         reject(xhr.status);
      //       }
      //     }
      //   };
      //   xhr.ontimeout = function () {
      //     reject("timeout");
      //   };
      //   xhr.open("GET", "https://www.cloudflare.com/cdn-cgi/trace", true);
      //   xhr.send();
      // });
    },
  },
};
</script>
<style lang="scss">
body {
  height: 100vh;
  padding-top: 88px;
}
.slither-enter-active,
.slither-leave-active {
  transition-duration: 0.25s;
  opacity: 1;
}
.slither-enter {
  transform: translateX(-100%);
  opacity: 0;
}
.slither-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

.slither-enter-to,
.slither-leave {
  transform: translateX(0);
}
</style>
